import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

const financialFrames = (state: RootState) =>
  state.financialFrames.financialFrames;
const loading = (state: RootState) => state.financialFrames.loading;
const loaded = (state: RootState) => state.financialFrames.loaded;
const updateLoading = (state: RootState) => state.financialFrames.updateLoading;
const error = (state: RootState) => state.financialFrames.error;

const selectFinancialFrames = createDraftSafeSelector(
  financialFrames,
  (financialFrames) => financialFrames || [],
);

const selectFinancialFramesLoading = createDraftSafeSelector(
  loading,
  (loading) => loading,
);

const selectFinancialFramesLoaded = createDraftSafeSelector(
  loaded,
  (loaded) => loaded,
);

const selectFinancialFramesError = createDraftSafeSelector(
  error,
  (error) => error,
);

const selectFinancialFrameUpdateLoading = createDraftSafeSelector(
  updateLoading,
  (updateLoading) => updateLoading,
);

export {
  selectFinancialFrames,
  selectFinancialFramesLoading,
  selectFinancialFramesLoaded,
  selectFinancialFramesError,
  selectFinancialFrameUpdateLoading,
};
